$(function() {

    let _offset_top = $(document).width() < 1024 ? 120 : 190;

    
    // Select all links with hashes
    $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
        
        // On-page links
        if (
            location.pathname.replace(/^\//, "") ==
                this.pathname.replace(/^\//, "") &&
            location.hostname == this.hostname
        ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $("html, body").animate(
                    {
                        scrollTop: target.offset().top - _offset_top,
                    },
                    800
                );
                $('li.menu-item').removeClass('active');
                
            }
        }
    });

    
    if (window.location.hash) {
        var hash = window.location.hash;
    
        if ($(hash).length) {
            $('html, body').animate({
                scrollTop: $(hash).offset().top - _offset_top
            }, 1,);
        }
    }
	
});

